<!--
Author: TangChen
Date: 2018-09-12
Desc: 执行结果页面，为公共组件
 -->
<template>
    <div class="comp-result comp">
        <div v-if="!result.specialasset" class="result-con">
            <div class="register-box" :class="result.cla">
                <span class="register-img" />
                <p class="register-text">
                    {{ result.msg }}
                </p>
            </div>
            <div class="register-btn border-top" :class="result.cla">
                <span class="register-btn-msg">{{ result.btnMsg?result.btnMsg:'' }}</span>
                <div v-if="result.transfer" class="transfer-msg">
                    <p class="tit">
                        请按照以下银行信息进行汇款:
                    </p>
                    <p><i>公司名称：</i><span>{{ result.transfer.acct_name }}</span></p>
                    <p><i>开户行：</i><span>{{ $cache.getDict('150003',result.transfer.bankid) }}</span></p>
                    <p><i>银行账号：</i><span>{{ result.transfer.acct_no }}</span></p>
                    <p v-if="result.transfer.cnaps.trim()">
                        <i>联行行号：</i><span>{{ result.transfer.cnaps }}</span><i>(异地汇款使用)</i>
                    </p>
                    <p v-if="result.transfer.bank_exchange_no.trim()">
                        <i>交换号：</i><span>{{ result.transfer.bank_exchange_no }}</span><i>(同城交换使用)</i>
                    </p>
                    <p v-if="result.transfer.big_cnaps.trim()">
                        <i>大额支付号：</i><span>{{ result.transfer.big_cnaps }}</span>
                    </p>
                </div>
                <el-row v-if="result.btnL||result.btnR" :class="{'padbot':!result.btnMsg}">
                    <el-button v-if="result.btnL.text" type="yellow" v-on:click.once="eventBtn('btnL')">
                        {{ result.btnL.text }}
                    </el-button>
                    <el-button v-if="result.btnR.text" type="back" v-on:click.once="eventBtn('btnR')">
                        {{ result.btnR.text }}
                    </el-button>
                    <div v-if="result.btnR.ctd" class="count-down">
                        <span v-if="time>0">{{ time }}</span>{{ result.btnR.ctd }}
                    </div>
                </el-row>
                <div v-if="result.warning&&result.warning.length>0" class="register-btn-msg warning">
                    <span class="tit">机构开户信息提示：</span>
                    <span v-for="(item,i) in result.warning" :key="i" class="grey">{{ item }}</span>
                </div>
            </div>
        </div>
        <div v-if="result.specialasset" class="result-buy-con">
            <el-steps class="result-msg" :active="active" align-center>
                <template v-if="result.btnGroup">
                    <el-step
                        v-for="(btn,index) in result.btnGroup"
                        :key="index"
                        :icon="'el-icon-cust index0'+ index"
                        :title="btn.tit"
                        :description="btn.text"
                    >
                        <i slot="prepend" class="el-icon-upload">123123</i>
                    </el-step>
                </template>
            </el-steps>
            <el-row class="btn-group">
                <template v-if="result.btnGroup">
                    <el-col v-for="(btn,index) in result.btnGroup" :key="index" :span="8">
                        <el-button
                            v-if="btn.btn"
                            :type="index===0?'primary':''"
                            :class="{'border-blue':index===1}"
                            v-on:click.once="toPage(btn.url)"
                        >
                            {{ btn.btn }}
                        </el-button>
                    </el-col>
                </template>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: "Result",
    props: {
        result: {
            type: Object,
            required: true
        },
        active: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            time: 0,
            btnMsg: ""
        };
    },
    mounted () {
        if (this.result.btnR.ctd) {
            if (this.result.btnR.time > 0) {
                this.time = this.result.btnR.time;
                this.$util.btnDisabled(this, function (_this) {
                    _this.$emit(_this.result["btnR"].event);
                });
            }
        }
    },
    methods: {
        eventBtn (v) {
            this.$emit(this.result[v].event);
        },
        toPage (val) {
            if (val === "return") {
                return this.$emit("return-page");
            }
            this.$router.push({ name: val });
        }
    }
};
</script>
<style lang="scss">
.comp-result {
    text-align: center;
    .register-box {
        padding: 30px 0 15px;
        .register-img {
            display: inline-block;
            width: 88px;
            height: 88px;
        }
        .register-text {
            padding-top: 7px;
            font-size: 24px;
            line-height: 40px;
        }
    }
    .warning{
        padding-top: 80px!important;
        text-align: left;
        .tit{font-size: 16px;}
        span{display: block;}
    }
    .transfer-msg {
        width: 800px;
        margin: 0 20px 20px 320px;
        text-align: left;
        p {
            font-size: 16px;
            line-height: 36px;
            &.tit {
                font-size: 14px;
            }
            i {
                font-style: normal;
                display: inline-block;
                width: 120px;
                text-align: right;
            }
        }
    }
    .register-btn {
        padding-bottom: 29px;
        .register-btn-msg {
            line-height: 30px;
            padding: 19px 0 17px;
            display: block;
        }
        .el-row {
            &.padbot {
                padding-bottom: 100px;
            }
            .el-button {
                min-width: 165px;
            }
            .el-button + .el-button {
                margin-left: 20px;
            }
            .count-down {
                font-size: 16px;
                display: inline-block;
                margin-left: 18px;
                span {
                    padding: 0 2px;
                }
            }
        }
    }
    .register-box.register-success {
        .register-img {
            background: url("../../assets/img/icon-result.png") 0 0 no-repeat;
        }
    }
    .register-box.register-fail {
        .register-img {
            background: url("../../assets/img/icon-result.png") -104px 0 no-repeat;
        }
    }
    .result-buy-con {
        .result-msg {
            position: relative;
            width: 960px;
            margin: 80px auto 46px;
            .el-step__description {
                font-size: 14px;
            }
            .el-step.is-horizontal .el-step__line {
                top: 35px;
                left: 65%;
                right: -35%;
            }
            .el-step__icon.is-icon {
                width: 71px;
                height: 71px;
                background-color: #acafb1;
                border-radius: 50%;
                .el-step__icon-inner {
                    width: 47px;
                    height: 47px;
                }
            }
            .el-step__title {
                font-size: 20px;
                &.is-process {
                    font-weight: normal;
                }
            }
        }
        .el-row.btn-group {
            width: 616px;
            margin: 0 auto;
            .el-col {
                text-align: center;
                .el-button {
                    width: 150px;
                }
            }
        }
    }
}
</style>
